export default function() {
  return new Worker(__webpack_public_path__ + "pdf.worker.entry-b0aef47d637b299e36ad.worker.js");
}
